import React from "react";
import { useNavigate } from "react-router-dom";

import {
  EXPLORE_SURVEY_NAV_ITEMS,
  ExploreSurveyNavSlug,
  exploreSurveyIntentPath,
} from "../../../configs/ExploreSurveyConfig";
import { pageConfigBySlug } from "../../../services/nav/NavigationService";

interface IProps {
  activeSlug: ExploreSurveyNavSlug;
  /** Step labels for the active survey — display only, not navigable. */
  stepLabels: string[];
  activeStepIndex: number;
}

/**
 * PowerGen-matching chrome: domain survey tabs + non-clickable section labels.
 */
export const ExploreSurveyChrome: React.FC<IProps> = (props) => {
  const { activeSlug, stepLabels, activeStepIndex } = props;
  const navigate = useNavigate();
  const exploreSlug = pageConfigBySlug("explore")?.slug || "explore";

  return (
    <div className="bg-white border rounded p-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          {EXPLORE_SURVEY_NAV_ITEMS.map((item) => {
            const isActive = item.slug === activeSlug;
            return (
              <button
                key={item.slug}
                type="button"
                className={
                  isActive
                    ? "px-4 py-1.5 rounded-md bg-zeos-orange-dk text-white text-sm"
                    : "px-4 py-1.5 rounded-md border border-zeos-orange-dk text-zeos-black text-sm"
                }
                onClick={() => {
                  if (isActive) {
                    return;
                  }
                  navigate(exploreSurveyIntentPath(exploreSlug, item.slug));
                }}
              >
                {item.title}
              </button>
            );
          })}
        </div>
      </div>

      {stepLabels.length > 0 && (
        <div className="flex flex-wrap items-center gap-6 mt-4 text-sm text-gray-600">
          {stepLabels.map((label, index) => {
            const isActive = index === activeStepIndex;
            const isLast = index === stepLabels.length - 1;
            return (
              <div key={`${label}-${index}`} className="flex items-center gap-2">
                <span
                  className={
                    isActive
                      ? "text-zeos-black font-semibold border-b-2 border-zeos-orange-dk pb-1"
                      : "text-gray-700 pb-1"
                  }
                >
                  {label}
                </span>
                {!isLast && <div className="w-16 h-px bg-gray-300" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const ExploreSurveyResourcesSidebar: React.FC = () => {
  return (
    <div className="col-span-12 lg:col-span-3 space-y-4">
      <div className="bg-white border rounded p-4">
        <div className="text-sm font-semibold text-zeos-black mb-3">
          Resources
        </div>
        <ul className="space-y-2 text-sm text-zeos-orange-dk">
          {[
            "Resource 1",
            "Resource 2",
            "Resource 3",
            "Resource 4",
            "Resource 5",
            "Resource 6",
          ].map((resource) => (
            <li key={resource} className="hover:underline cursor-pointer">
              {resource}
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-zeos-orange-dk text-white rounded p-6 space-y-4">
        <div>
          <div className="text-lg font-semibold">Energy Legislation</div>
          <div className="text-sm">And what it means for you</div>
        </div>
        <p className="text-xs leading-5">
          Energy regulations change quickly. ZEOS-AI continuously monitors these
          changes to ensure you always have the latest compliance information.
        </p>
        <button
          type="button"
          className="bg-white text-zeos-orange-dk text-xs font-semibold px-4 py-2 rounded"
        >
          GET CONNECTED
        </button>
      </div>
    </div>
  );
};
